(function () {
  var labels = {
    en: {
      survey: "SHAPPY survey of 100 customers who had used the sofa for at least 3 months",
      quotes: "Selected comments from SHAPPY customers",
      judgeme: "Customer reviews on Judge.me"
    },
    de: {
      survey: "SHAPPY Kundenumfrage unter 100 Kundinnen und Kunden, die das Sofa mindestens 3 Monate genutzt hatten",
      quotes: "Ausgewählte Stimmen von SHAPPY Kundinnen und Kunden",
      judgeme: "Kundenbewertungen auf Judge.me"
    },
    fr: {
      survey: "Enquête SHAPPY menée auprès de 100 clients ayant utilisé le canapé pendant au moins 3 mois",
      quotes: "Témoignages sélectionnés de clients SHAPPY",
      judgeme: "Avis clients sur Judge.me"
    },
    es: {
      survey: "Encuesta de SHAPPY a 100 clientes que habían utilizado el sofá durante al menos 3 meses",
      quotes: "Comentarios seleccionados de clientes de SHAPPY",
      judgeme: "Opiniones de clientes en Judge.me"
    },
    nl: {
      survey: "SHAPPY-enquête onder 100 klanten die de speelbank minstens 3 maanden hadden gebruikt",
      quotes: "Geselecteerde reacties van SHAPPY-klanten",
      judgeme: "Klantbeoordelingen op Judge.me"
    }
  };

  var language = (document.documentElement.lang || "en").slice(0, 2).toLowerCase();
  var copy = labels[language] || labels.en;

  function setText(element, value) {
    if (element && element.textContent.trim() !== value) element.textContent = value;
  }

  function applyProofLabels() {
    var fullSurvey = document.querySelector('[id*="__custom_html_3cpWBn"]');
    var miniSurvey = document.querySelector('[id*="__custom_html_k8gAiE"]');
    var surveySection = fullSurvey || miniSurvey;

    if (surveySection) {
      setText(surveySection.querySelector('p[style*="font-size:12.5px"]'), copy.survey);
    }

    if (fullSurvey) {
      setText(
        document.querySelector('[id*="__custom_html_rJ9eRW"] h2'),
        copy.quotes
      );
      setText(document.querySelector('.jdgm-rev-widg__title'), copy.judgeme);
    }

    document.querySelectorAll('.shappy-judgeme-label').forEach(function (element) {
      element.style.setProperty('display', 'none', 'important');
    });
  }

  [0, 250, 1000, 2500, 5000].forEach(function (delay) {
    window.setTimeout(applyProofLabels, delay);
  });
})();
